import styled from 'styled-components';

export const StyledLoader = styled.img`
  width: 30px;
  height: 30px;
  display: block;
  margin: 2px auto;
`;
